module.exports = __webpack_public_path__ + "assets/img/center_ncbc_logo.4f902d84.png";